import translations from './translations'

translations.add('is', {
    description: 'Eitthvað fór úrskeiðis! Athugaðu gögnin eða reyndu aftur síðar.',
    close: 'LOKA'
})
